// extracted by mini-css-extract-plugin
export default {"empty":"styles-module__empty__src-labstep-web-core-Action-Menu-_OIWE2"};